
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB1UExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/1GL/5u8/1GK/0WC/+bv/////9rm/83e/8DV/6jF /4+0/7TN/2mb/12T/2qb/6jE//L3/9nm/+bu/wAAAP5zZUsAAAASdFJOUwBAj9/PnyAQkI/PQM/P jxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5wwEAzkj I6K5XQAAALdJREFUKM990u0SgiAQBdANRTQraxUly6/M93/FRFEp2e4fGM4s7AwLMObAPPyKzwOY I0J0JBKT+ejMUWuIRCKAAMnEwGlkcDK7NNNBmW/owbIrlA5md0tXVAaVpXu01IGqJNB6cI+PuWc3 mssdKJ9VVacENi2i7Ah86bUmsM+7BnsC1bsYSqohuttis2HFZbTmL5sizdEZLvRnc4hpHMeTLGXj 9CX/RhMSZy0TZuYD/lN9ZTd9/gG2WzcPrPqM6QAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0w NFQwMjozMjoxNiswMDowMKI3jFEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6 MTYrMDA6MDDTajTtAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM1KzAw OjAwJLjQUAAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    